export default "__VITE_ASSET__2d17b482__"